/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FxIdDomainSettingsPublicWebClientConfigOptionsWebPushFromJSON, FxIdDomainSettingsPublicWebClientConfigOptionsWebPushToJSON, } from './FxIdDomainSettingsPublicWebClientConfigOptionsWebPush';
import { FxIdDomainSettingsPortalPublicWebConfigOptionsCompanyBrandingFromJSON, FxIdDomainSettingsPortalPublicWebConfigOptionsCompanyBrandingToJSON, } from './FxIdDomainSettingsPortalPublicWebConfigOptionsCompanyBranding';
/**
 * Check if a given object implements the FxIdDomainSettingsPortalPublicWebConfigOptions interface.
 */
export function instanceOfFxIdDomainSettingsPortalPublicWebConfigOptions(value) {
    if (!('CompanyBranding' in value) || value['CompanyBranding'] === undefined)
        return false;
    return true;
}
export function FxIdDomainSettingsPortalPublicWebConfigOptionsFromJSON(json) {
    return FxIdDomainSettingsPortalPublicWebConfigOptionsFromJSONTyped(json, false);
}
export function FxIdDomainSettingsPortalPublicWebConfigOptionsFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'CompanyBranding': FxIdDomainSettingsPortalPublicWebConfigOptionsCompanyBrandingFromJSON(json['CompanyBranding']),
        'WebPush': json['WebPush'] == null ? undefined : FxIdDomainSettingsPublicWebClientConfigOptionsWebPushFromJSON(json['WebPush']),
    };
}
export function FxIdDomainSettingsPortalPublicWebConfigOptionsToJSON(json) {
    return FxIdDomainSettingsPortalPublicWebConfigOptionsToJSONTyped(json, false);
}
export function FxIdDomainSettingsPortalPublicWebConfigOptionsToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'CompanyBranding': FxIdDomainSettingsPortalPublicWebConfigOptionsCompanyBrandingToJSON(value['CompanyBranding']),
        'WebPush': FxIdDomainSettingsPublicWebClientConfigOptionsWebPushToJSON(value['WebPush']),
    };
}
//# sourceMappingURL=FxIdDomainSettingsPortalPublicWebConfigOptions.js.map